import SEO from "./SEO"
import { useState } from "react"
import { Header } from "../components/Header"
import { Footer } from "../components/Footer"
import { Button } from "../components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card"
import { Input } from "../components/ui/input"
import { Label } from "../components/ui/label"
import { Textarea } from "../components/ui/textarea"
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue
} from "../components/ui/select"
import { Clock, Phone, Mail, MapPin,Facebook ,Instagram,Linkedin } from "lucide-react"

export default function BookAppointmentPage() {
  // ADD STATES HERE
  const [service, setService] = useState("")
  const [time, setTime] = useState("")

  const handleSubmit = async (e) => {
      e.preventDefault();

      const formData = {
        firstName: e.target.firstName.value,
        lastName: e.target.lastName.value,
        email: e.target.email.value,
        phone: e.target.phone.value,
        service,
        date: e.target.date.value,
        time,
        message: e.target.message.value
      };

      // If email sent successfully → THEN open WhatsApp
      const waMsg = `
    *New Appointment Request*

    Name: ${formData.firstName} ${formData.lastName}
    Email: ${formData.email}
    Phone: ${formData.phone}
    Service: ${formData.service}
    Date: ${formData.date}
    Time: ${formData.time}

    Message: ${formData.message}
    `;

      window.open(
        `https://wa.me/919989345545?text=${encodeURIComponent(waMsg)}`,
        "_blank"
      );

      alert("Appointment request submitted successfully!");
    };


  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Book an Orthopedic Appointment in Hyderabad | Dr. Sujit Kumar"
        description="Request an appointment with Dr. Sujit Kumar for orthopedic consultation in Hyderabad, including joint, hand, wrist and sports injury care."
        keywords="book orthopedic appointment Hyderabad, Dr Sujit Kumar appointment, orthopedic consultation Hyderabad, sports injury appointment"
        canonical="https://www.drsujitkumar.com/book-appointment"
        robots="index, follow"
      />
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4 font-[family-name:var(--font-playfair)]">
              Book an Appointment
            </h1>
            <p className="text-lg text-primary-foreground/90 leading-relaxed">
              Schedule your consultation with Dr. Sujit Kumar and take the first step towards recovery.
            </p>
          </div>
        </div>
      </section>

      {/* Booking Form Section */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Booking Form */}
            <div className="lg:col-span-2">
              <Card>
                <CardHeader>
                  <CardTitle className="text-2xl">Appointment Request Form</CardTitle>
                  <CardDescription>
                    Fill out the form below and we'll contact you to confirm your appointment within 24 hours.
                  </CardDescription>
                </CardHeader>

                <CardContent>
                  <form className="space-y-6" onSubmit={handleSubmit} >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="firstName">First Name *</Label>
                        <Input
                            id="firstName"
                            placeholder="Enter Your Name"
                            required
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
                            }}
                          />
                          </div>

                      <div className="space-y-2">
                        <Label htmlFor="lastName">Last Name *</Label>
                       <Input
                            id="lastName"
                            placeholder="Enter Your Name"
                            required
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
                            }}
                          />

                      </div>
                    </div>

                    {/* Email & Phone */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="email">Email *</Label>
                        <Input id="email" type="email" placeholder="john@example.com" required />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="phone">Phone Number *</Label>
                        <Input
                              id="phone"
                              type="tel"
                              placeholder="9999999999"
                              required
                              maxLength={10}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                              }}
                            />

                      </div>
                    </div>

                    {/* FIXED SERVICE SELECT */}
                    <div className="space-y-2">
                      <Label htmlFor="service">Service Required *</Label>
                          <Select value={service} onValueChange={setService}>
                            <SelectTrigger>
                              <SelectValue placeholder="Select a service" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="arthroscopy">Arthroscopy</SelectItem>
                              <SelectItem value="sports-injury">Sports Injury Management</SelectItem>
                              <SelectItem value="fracture">Fracture & Trauma Care</SelectItem>
                              <SelectItem value="joint-replacement">Joint Replacement</SelectItem>
                              <SelectItem value="shoulder-knee-hip">Shoulder, Knee & Hip Care</SelectItem>
                              <SelectItem value="physiotherapy">Physiotherapy & Rehab</SelectItem>
                              <SelectItem value="general">General Consultation</SelectItem>
                            </SelectContent>
                          </Select>
                    </div>

                    {/* Date + Time */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="date">Preferred Date *</Label>
                        <Input id="date" type="date" required />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="time">Preferred Time *</Label>

                        {/* FIXED TIME SELECT */}
                        <Select value={time} onValueChange={setTime}>
                          <SelectTrigger id="time" className="focus:ring-0 focus:outline-none">
                            <SelectValue placeholder="Select time" />
                          </SelectTrigger>

                          <SelectContent>
                            <SelectItem value="morning">Morning (9:00 AM - 12:00 PM)</SelectItem>
                            <SelectItem value="afternoon">Afternoon (12:00 PM - 3:00 PM)</SelectItem>
                            <SelectItem value="evening">Evening (3:00 PM - 6:00 PM)</SelectItem>
                          </SelectContent>
                        </Select>

                      </div>
                    </div>

                    {/* Message */}
                    <div className="space-y-2">
                      <Label htmlFor="message">Additional Information</Label>
                      <Textarea
                        id="message"
                        placeholder="Please describe your condition..."
                        rows={4}
                      />
                    </div>

                    <Button type="submit" size="lg" className="w-full sm:w-auto">
                      Submit Appointment Request
                    </Button>

                    <p className="text-sm text-muted-foreground">
                      * Required fields. You will receive a confirmation within 24 hours.
                    </p>
                  </form>
                </CardContent>
              </Card>
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle>Contact Information</CardTitle>
                </CardHeader>

                <CardContent className="space-y-4">
                  <div className="flex items-start gap-3">
                    <Phone className="h-5 w-5 " />
                    <div>
                      <p className="font-medium">Phone</p>
                      <a href="tel:+917995918882" className="text-muted-foreground hover:text-primary">
                        +91 9989345545
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Mail className="h-5 w-5 " />
                    <div>
                      <p className="font-medium">Email</p>
                      <a href="mailto:vrsujitkumar@gmail.com" className="text-muted-foreground hover:text-primary">
                        vrsujitkumar@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <MapPin className="h-5 w-5 " />
                    <div>
                      <p className="font-medium">Address</p>
                      <p className="text-muted-foreground text-sm">
                        Flat No. G8, SERENE VIEW Apartment Complex
                        <br />PJR Enclave Main Road
                        <br />Madhavapuri Hills, Chanda Nagar
                        <br />Telangana 502032
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary/10  flex-shrink-0">
                      <Facebook className="h-5 w-5 " />
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Social Media</h3>
                      <li className="flex items-center gap-2">
                <Facebook className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.facebook.com/OrthopedicSportsInjuryClinic"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground"
                >
                  Follow us on Facebook
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.instagram.com/drsujit_sportssurgeon?utm_source=qr&igsh=MXR1MGl6dmx6MGU0ZA=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground"
                >
                  Follow us on Instagram
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Linkedin className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.linkedin.com/in/vrsujit-kumar-94bb6619?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground"
                >
                  Connect on LinkedIn
                </a>
              </li>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-secondary text-secondary-foreground">
                <CardHeader>
                  <CardTitle>Clinic Hours</CardTitle>
                </CardHeader>
                <CardContent className="space-y-2">
                  <div className="flex items-center gap-2">
                    <Clock className="h-4 w-4" />
                    <span className="font-medium">Monday - Saturday</span>
                  </div>
                  <p className="ml-6 text-secondary-foreground/90">5:00 PM - 8:30 PM (By Appointment Only)</p>

                  {/* <div className="flex items-center gap-2 mt-4">
                    <Clock className="h-4 w-4" />
                    <span className="font-medium">Sunday</span>
                  </div>
                  <p className="ml-6 text-secondary-foreground/90">By Appointment Only</p> */}
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Emergency?</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground mb-4">
                    For urgent cases, please call us directly.
                  </p>

                  <Button variant="outline" className="w-full" asChild>
                    <a href="tel:+919989345545">
                      <Phone className="mr-2 h-4 w-4" />
                      Call Now
                    </a>
                  </Button>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}
